exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome-data label {\n    font-weight: bold;\n\tmargin: 0;\n}\n.welcome-data h5 {\n    text-transform: capitalize;\n}\n.m-b-15 {\n    margin-bottom: 15px;\n}\n.iconButton:focus {\n    outline: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/event/welcome/welcome.component.css
// module id = ../../../../../src/app/event/welcome/welcome.component.css
// module chunks = main